import type { DirectoryFilters } from '../types/domain'

export const queryKeys = {
  accessState: ['access-state'] as const,
  profile: (profileId: string) => ['profile', profileId] as const,
  batches: ['batches'] as const,
  directory: (filters: DirectoryFilters) => ['directory', filters] as const,
  directoryProfile: (profileId: string) => ['directory-profile', profileId] as const,
  applications: (status: string, q: string, batchId: string, memberType: string, page: number) =>
    ['membership-applications', status, q, batchId, memberType, page] as const,
  applicationCounts: (q: string, batchId: string, memberType: string) =>
    ['membership-application-counts', q, batchId, memberType] as const,
  alumni: (q: string, status: string, memberType: string, page: number) =>
    ['admin-alumni', q, status, memberType, page] as const,
  adminAlumniProfile: (profileId: string) => ['admin-alumni-profile', profileId] as const,
  audit: (page: number) => ['audit', page] as const,
  batchAdmins: (q: string, status: string, page: number) =>
    ['batch-admins', q, status, page] as const,
  operationsAdmins: (q = '', status = '', page = 1) =>
    ['operations-admins', q, status, page] as const,
  events: (scope = '', page = 1) => ['events', scope, page] as const,
  event: (eventId: string) => ['event', eventId] as const,
  eventCover: (eventId: string) => ['event-cover', eventId] as const,
  communities: ['communities'] as const,
  adminCommunities: ['admin-communities'] as const,
  adminCommunityMembers: (communityId: string) => ['admin-community-members', communityId] as const,
  communityPosts: (communityId: string) => ['community-posts', communityId] as const,
  communityCommentsRoot: ['community-comments'] as const,
  communityComments: (postId: string) => ['community-comments', postId] as const,
  conversations: ['conversations'] as const,
  contactRequests: ['contact-requests'] as const,
  messages: (conversationId: string) => ['messages', conversationId] as const,
  notifications: ['notifications'] as const,
  notificationPreferences: ['notification-preferences'] as const,
  adminAnnouncements: ['admin-announcements'] as const,
  announcements: ['announcements'] as const,
  operationalAudit: ['operational-audit'] as const,
  moderation: ['moderation'] as const,
}
